import application from "stimulus_init"

// Stimulus has no public "is this identifier registered?" check, so read the
// router's registry. Another bundle may already have registered the
// controller eagerly (stimulus_author registers `select`), and registering it
// again would reconnect every controller of that identifier on the page.
const isRegistered = (identifier) => application.router.modulesByIdentifier.has(identifier)

// Bundles are synchronous scripts, so by DOMContentLoaded every bundle on the
// page has run. Editorial layouts load application before author, and author
// registers `select` eagerly.
const whenBundlesLoaded = () => {
  if (document.readyState !== "loading") return Promise.resolve()

  return new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", resolve, { once: true })
  })
}

// Download and register a Stimulus controller only on pages that use it, the
// way registerComponent does for React mounts. The page is checked once, at
// load, so elements added later won't trigger the download.
//
//   lazyController("select", () => import("controllers/railsblocks/select_controller"))
//
export const lazyController = async (identifier, loadController) => {
  await whenBundlesLoaded()

  if (isRegistered(identifier)) return
  if (!document.querySelector(`[data-controller~="${identifier}"]`)) return

  const { default: controller } = await loadController()

  // Another registration may have finished while the import was in flight.
  if (isRegistered(identifier)) return

  application.register(identifier, controller)
}
